import { Grid } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { numberWithCommas } from '../../../../../utils/numberWithCommas';
import styles from './ModelDetails.module.scss';
import { loadExteriorImg } from '../../../../../redux/agreement/actions';
import { setUnavailable } from '../../../../../api/LotMatrix/lotMatrix.api';

const Modeldetails = ({
	modelDetails,
	loadExteriorImg,
	exteriorImage,
	totalOptionPrice,
}) => {
	useEffect(() => {
		if (exteriorImage.length === 0 && modelDetails) {
			loadExteriorImg(
				modelDetails?.modelName,
				modelDetails?.elevation?.id?.toLowerCase()
			);
		}

		setUnavailable(
			modelDetails?.modelName,
			modelDetails?.elevation?.id,
			modelDetails?.lotId
		);
	}, []);

	return (
		<div className={styles.modelDetailsWrapper}>
			<h2 className={styles.title}>{modelDetails.modelName}</h2>
			<div className={styles.details}>
				<div className={styles.item}>{modelDetails?.lotSizeType}'</div>
				<div className={styles.item}>
					<Grid
						container
						className={styles.itemLayout}
						justifyContent='space-between'
					>
						<Grid item className={styles.label}>
							Elevation {modelDetails?.elevation?.id}
						</Grid>
						<Grid item className={styles.description}>
							{`$${numberWithCommas(
								Number(modelDetails?.elevation?.price).toFixed(
									2
								)
							)}`}
						</Grid>
					</Grid>
				</div>
				<div className={styles.item}>
					<Grid
						container
						className={styles.itemLayout}
						justifyContent='space-between'
					>
						<Grid item className={styles.label}>
							Upgrade{' '}
							{modelDetails?.upgrade?.name &&
								`- ${modelDetails?.upgrade?.name}`}
						</Grid>
						<Grid item className={styles.description}>
							{modelDetails &&
								`$${numberWithCommas(
									Number(
										modelDetails?.upgrade?.price || 0
									).toFixed(2)
								)}`}
						</Grid>
					</Grid>
				</div>
				<div className={styles.item}>
					<Grid
						container
						className={styles.itemLayout}
						justifyContent='space-between'
					>
						<Grid item className={styles.label}>
							Grade
						</Grid>
						<Grid item className={styles.description}>
							{modelDetails &&
								`$${numberWithCommas(
									Number(
										modelDetails?.grade?.price || 0
									).toFixed(2)
								)}`}
						</Grid>
					</Grid>
				</div>
				<div className={styles.item}>
					<Grid
						container
						className={styles.itemLayout}
						justifyContent='space-between'
					>
						<Grid item className={styles.label}>
							Premium Lot {modelDetails?.lotId}
						</Grid>
						<Grid item className={styles.description}>
							{modelDetails &&
								`$${numberWithCommas(
									Number(modelDetails?.lotPrice)
										// + Number(
										// 	modelDetails?.grade?.price
										// 		? modelDetails.grade.price
										// 		: 0
										// )
										// + Number(
										// 	modelDetails?.upgrade?.price
										// 		? modelDetails.upgrade.price
										// 		: 0
										// )
										.toFixed(2)
								)}`}
						</Grid>
					</Grid>
				</div>
				<div className={styles.item}>
					<Grid
						container
						className={styles.itemLayout}
						justifyContent='space-between'
					>
						<Grid item className={styles.label}>
							Closing Date
						</Grid>
						<Grid item className={styles.description}>
							{dayjs(modelDetails?.closingDate).format(
								'MMM DD, YYYY'
							)}
						</Grid>
					</Grid>
				</div>

				<div className={styles.item}>
					<Grid
						container
						className={styles.itemLayout}
						justifyContent='space-between'
					>
						<Grid item className={styles.label}>
							Options
						</Grid>

						<Grid item className={styles.description}>
							{totalOptionPrice
								? `$${numberWithCommas(
										Number(totalOptionPrice).toFixed(2)
								  )}`
								: '$0'}
						</Grid>
					</Grid>
				</div>
			</div>
			<Grid
				container
				className={styles.total}
				justifyContent='space-between'
			>
				<Grid item className={styles.label}>
					Total
				</Grid>
				<Grid item className={styles.description}>
					{`$${numberWithCommas(
						(
							Number(modelDetails?.lotPrice) +
							Number(
								modelDetails?.grade?.price
									? modelDetails.grade.price
									: 0
							) +
							Number(
								modelDetails?.upgrade?.price
									? modelDetails.upgrade.price
									: 0
							) +
							Number(modelDetails?.elevation?.price) +
							Number(totalOptionPrice)
						).toFixed(2)
					)}`}
				</Grid>
			</Grid>

			<div className={styles.image}>
				<img src={exteriorImage[0]} alt='' />
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	modelDetails:
		state.agreement.agreementById?.productAvailability ||
		state.agreement.productAvailability,
	exteriorImage: state.agreement.exteriorImage,
});

export default connect(mapStateToProps, { loadExteriorImg })(Modeldetails);
